'use strict';
const angular = require('angular');
const {forEach, isArray, isFunction, isString} = angular;
const includes = require('lodash/includes');

export const $$ConstraintsImport = [
  '$log',
  '$window',
  'DomainBootstrapper',
  '$domain',
  '$$DomainCollection',
  '$$DomainUtilities',
  $$Constraints];

function $$Constraints(
  $log,
  $window,
  DomainBootstrapper,
  $domain,
  DomainCollection,
  DomainUtilities,
) {

  function Constraints(Class) {
    Object.defineProperty(this, '$$class', {
      value: Class
    });
  }

  /**
   * Defines a validatable property on the class.
   * @param {string} propertyName
   * @param {Object} constraint
   * @param {string} constraint.type
   */
  Constraints.prototype.addConstraint = function (propertyName, constraint) {
    if (!constraint.type)
      throw new Error('Invalid constraint added for class ' + this.$$class.$name + '. Type must be defined and must be a non empty-string.');

    var getMethodName = '$get' + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
    var createMethodName = '$create' + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
    switch (constraint.type) {
      case 'Domain':
      case 'DomainLink':
        Object.defineProperty(this, propertyName, {enumerable: true, value: constraint});
        if (constraint.domainClass) {
          //console.log('assigning Domain Class ' + constraint.domainClass + ' to constraint ' + propertyName);

          // We must inject any Constructor factories at run-time.
          __queueDomainInjection(constraint, propertyName);
        } else {
          Object.defineProperty(constraint, '$$registeredLinks', {value: []});
        }

        // default values
        if (propertyName === 'createdBy' &&
          ((isFunction(constraint.domainClass) && constraint.domainClass.$name === $domain.$$userDomainName)
          || (isString(constraint.domainClass) && constraint.domainClass === $domain.$$userDomainName))) {

          constraint.defaultValue = $domain.$$currentUser;
        }
        break;

      case 'NestedDocument':
        Object.defineProperty(this, propertyName, {enumerable: true, value: constraint});
        // TODO(NestedDocument): determine if there is any additional setup needed for NestedDocument type

        if (!isFunction(constraint.nestedDocumentClass))
          throw new Error('DomainClass: Defined invalid NestedDocument Constraint. nestedDocumentClass must be a valid constructor function matching the NestedDocument interface.');

        this.$$class.prototype[createMethodName] = function (data) {
          return constraint.nestedDocumentClass(this, data, propertyName);
        };

        // TODO(NestedDocument): consider type checking the constructor prototype to validate each required interface method is defined.
        break;

      case 'LinkedDocument':
        Object.defineProperty(this, propertyName, {enumerable: true, value: constraint});

        // We must inject any Constructor factories at run-time.
        __queueDomainInjection(constraint, propertyName);

        this.$$class.prototype[getMethodName] = $domain.cacheResult(this.$$class.$name + '-' + getMethodName, function () {
          var self = this;
          return constraint.domainClass.$get(self.$id).then(function (it) {
            return it ? it : self[createMethodName]();
          });
        });

        this.$$class.prototype[createMethodName] = function () {
          var newItem = constraint.domainClass.$factory.create();
          newItem.$id = this.$id;
          return newItem.$save().then(function () {
            return newItem;
          });
        };
        break;

      case 'DomainCollection':
        // DO NOT iterate over collection properties, breaks lazy loading and angular
        var camelCase = DomainUtilities.camelCase(propertyName);
        var dash = DomainUtilities.dashSeparate(propertyName);
        var listName = isString(constraint.listName) ? constraint.listName : dash;

        Object.defineProperty(constraint, 'collectionClass',
          {value: new DomainCollection(this.$$class, listName, constraint)});

        Object.defineProperty(this, camelCase, {enumerable: true, value: constraint});

        $log.debug('Defining DomainCollection on class ' + this.$$class.$name + ' with');
        $log.debug('  property name: ' + camelCase);
        $log.debug('  list name    : ' + listName);
        break;

      default:
        Object.defineProperty(this, propertyName, {enumerable: true, value: constraint});

        // dynamic methods:

        if (isArray(constraint.inList)) {
          __configInListMethods(this.$$class, propertyName, constraint);
        }

        // default values
        if (constraint.type === 'Date') {
          if (propertyName === 'dateCreated' || propertyName === 'lastUpdated') {
            constraint.defaultValue = function () {
              return $window.Firebase.ServerValue.TIMESTAMP;
            }
          }
        }
    }
  };

  Constraints.prototype.addConstraints = function (constraints) {
    forEach(constraints, function (constraint, field) {
      this.addConstraint(field, constraint);
    }, this);
  };

  function __queueDomainInjection(constraint, propertyName) {
    // We must inject any Constructor factories at run-time.
    DomainBootstrapper.queue(function (injector) {
      var domainClassName = constraint.domainClass;
      if (!isString(domainClassName)) {
        // TODO: verify the this.$name usage is the correct reference
        throw new Error('attempting to inject invalid domain class into constraint ' + propertyName + ' of class ' + this.$name, constraint.domainClass);
      }
      try {
        constraint.domainClass = injector.get(domainClassName);
        //console.log('assigned Domain Class ' + constraint.domainClass.name + ' to constraint ' + propertyName);
      } catch (errors) {
        console.error('Could not retrieve ' + domainClassName + '. Please make sure the domain class is defined as an angular factory or a provider.');
      }
    });
  }

  function __configInListMethods(Class, field, constraint) {
    Class['$' + field + 'HasInList'] = function (it) {
      return includes(constraint.inList, it);
    };

    Class.prototype['$' + field + 'HasInList'] = Class['$' + field + 'HasInList'];
  }

  return {
    Constraints,
  };
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/domain-properties/Constraints.js